import { create } from "zustand";

type State = {
  tradesInProcess: string[];
};

type Action = {
  // eslint-disable-next-line no-unused-vars
  addTradeInProcess: (incomingData: string[]) => void;
  // eslint-disable-next-line no-unused-vars
  removeTradeInProcess: (incomingData: string[]) => void;
};

const tradesInProcessStore = create<State & Action>((set) => ({
  tradesInProcess: [],
  addTradeInProcess: (incomingData) => {
    set(() => ({
      tradesInProcess: incomingData,
    }));
  },
  removeTradeInProcess: (incomingData) => {
    set(() => ({
      tradesInProcess: incomingData,
    }));
  },
}));

export default tradesInProcessStore;
